import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberWithPercentageSymbol'
})
export class NumberWithPercentageSymbolPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) { }

    transform(amount: number | string | null, fractionDigits: number = 2): any {
        if (amount === null || amount === undefined) {
            return null;
        }

        if (typeof amount === 'string') {
            amount = parseFloat(amount);
        }

        if (isNaN(amount)) {
            return '';
        }
        const format = `1.${fractionDigits}-${fractionDigits}`;
        amount = this.decimalPipe.transform(amount, format);
        return `${amount}%`;
    }
}
